import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-arrow-right.png'


const _withScopeId = n => (_pushScopeId("data-v-7dd94107"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-shop" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"mask\" data-v-7dd94107><div class=\"shop-name\" data-v-7dd94107> Sponsored box </div><div class=\"box-action\" data-v-7dd94107><span data-v-7dd94107>Learn more</span><div class=\"btn-arrow\" data-v-7dd94107><img src=\"" + _imports_0 + "\" data-v-7dd94107></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

import { IShop } from '@/types/shop';

  export interface IProps {
    shop: IShop;
  }

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})